var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResourceTable',_vm._g(_vm._b({attrs:{"rows":_vm.filterRow,"groupable":false,"schema":_vm.schema,"key-field":"_key"}},'ResourceTable',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }